// useCatalogueStatus.ts
import * as signalR from "@microsoft/signalr";
import { useEffect, useRef, useState } from "react";
import { API_URL } from "../_config/config.const";
import { auctionMessageService } from "../_services/auctionMessage.service";
import { accountService } from "../_services/accounts.service";

const API_NAME = "auctionMessage";

export function useAuctionMessage(auctionId?: number) {

    const [_messages, setMessages] = useState<Array<any> | null>(null);

    const [connected, setConnected] = useState(false);
    const connRef = useRef<signalR.HubConnection | null>(null);

    useEffect(() => {
        if (!auctionId) return;

        const currentUser = accountService.currentUserValue;

        const conn = new signalR.HubConnectionBuilder()
            .withUrl(`${API_URL}/hubs/${API_NAME}`, {
                // withCredentials: true,
                accessTokenFactory: () => currentUser.token
            })
            .withAutomaticReconnect([0, 1000, 2000, 5000, 10000])
            .build();

        connRef.current = conn;

        conn.on("AddMessage", (item: any) => {
            // Use the functional updater (not the stale `_messages` closure) so a
            // message reliably stays in the list. It is only ever removed by an
            // explicit RemoveMessage (admin clicking the x), never on its own.
            setMessages((prev: any) => {
                const list = Array.isArray(prev) ? prev : [];
                if (item?.id != null && list.some((m: any) => m.id === item.id)) return list;
                return [item, ...list];
            });
        });

        conn.on("RemoveMessage", (id: number) => {
            setMessages((prev: any) => Array.isArray(prev) ? prev.filter((m: any) => m.id != id) : prev);
        });

        (async () => {
            try {
                await conn.start();
                setConnected(true);

                return auctionMessageService.getAll(auctionId).then(d => {
                    setMessages(d)
                })
            } catch (err) {
                console.error("SignalR connect failed", err);
            }
        })();

    }, [auctionId]);

    const messages = Array.from(new Map(_messages?.map((x) => [x.id, x])).values());

    return { messages, connected };
}